import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=0a66c4c9&scoped=true&"
import script from "./ProfileMenu.vue?vue&type=script&lang=js&"
export * from "./ProfileMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMenu.vue?vue&type=style&index=0&id=0a66c4c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a66c4c9",
  null
  
)

export default component.exports